import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbef594a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttensiDropdown = _resolveComponent("AttensiDropdown")!

  return (_openBlock(), _createBlock(_component_AttensiDropdown, {
    modelValue: _ctx.selectedOption,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
    searching: "",
    options: _ctx.options ?? []
  }, {
    "input-content": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.selectedOption?.title || _ctx.placeholder), 1)
    ]),
    "no-search-results": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('facilitator_tools.dropdown_no_results')), 1)
    ]),
    option: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(data.title), 1),
        (data.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(data.description.substring(0, 150)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}